import List from '@/views/app/MistreatmentTypes'
import OsmIntegration from '@/views/app/MistreatmentTypes/OsmIntegration'
import React from 'react'
import { Route, useRouteMatch } from 'react-router-dom'

function MistreatmentTypesRoutes() {
  const { path } = useRouteMatch()

  return (
    <div>
      <Route path={path} exact>
        <List title="Petis - Parceiros / Tipos de denúncia" />
      </Route>
      <Route path={`${path}/:id/osm-integration`} exact>
        <OsmIntegration title="Petis - Parceiros / Tipos de denúncia/Integração com OS-m" />
      </Route>
    </div>
  )
}

export default MistreatmentTypesRoutes
